module.exports = __webpack_public_path__ + "img/eligibility-questions-popup.909a469e.svg";